import React, { Component } from 'react';
import { toast, ToastContainer } from "react-toastify";
import moment from 'moment';
// import { imageExists } from '../../selectors/index';
import PriceBar from '../SubComponents/PriceBar/PriceBarContainer';
import Header from '../SubComponents/Header/Header';
import Footer from '../SubComponents/Footer/Footer';
import ClickableBox from '../SubComponents/ClickableBox/ClickableBox';
import './SequenceSelection.css';

export default class SequenceSelection extends Component {

  constructor(props) {
    super(props);

    this.onClickPrev = this.onClickPrev.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.inputFrozen = false;

  }

  componentWillMount() {
  }

  componentDidMount() {
    this.inputFrozen = false;
    //check if extra life day, if it is try to go straight to station select
    if ((moment(this.props.selectedDate).isSame(moment('2019-11-02'), 'day') || moment(this.props.selectedDate).isSame(moment('2019-11-03'), 'day')) && this.props.extraLifeAutoComplete) {
      this.props.setExtraLifeAutoComplete(false);
      let navSequence = this.props.sequences.filter(sequence => sequence.sequence_steps.some(sequence_option => Number(sequence_option.sequence_item_id) === -1) && sequence.sequence_steps.some(sequence_option => Number(sequence_option.sequence_item_id) === 1) && sequence.sequence_steps.length === 2 && sequence.active) 
      if (navSequence.length !== 0 && navSequence !== undefined && navSequence !== null) {
        this.onClickExtraLife(navSequence[0])
      } else {
        this.notifySequenceError();
      }
    }

  }

  notifySequenceError = () => toast('Date error occured. Please contact live chat', {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    hideProgressBar: true,
    className: "fail"
});

  updateSequence = sequence => {
    if (!this.inputFrozen) {
      this.props.updateSequence(sequence).catch(error => {
        console.error('Unable to update sequence: ' + error);
      });
    }
  }

  onClickExtraLife = (sequence) => {
    if (!this.inputFrozen) {
      this.updateSequence(sequence);
      this.props.transitionForward().catch((error) => {
        console.error('Failed to go forward from sequence selection: ' + error);
      });
    }
  }

  onClickSequence = (sequence) => () => {
    if (!this.inputFrozen) {
      this.updateSequence(sequence);
      this.props.transitionForward().catch((error) => {
        console.error('Failed to go forward from sequence selection: ' + error);
      });
    }
  }

  onClickNext = () => { }

  onClickPrev = () => {
    if (!this.inputFrozen) {
      this.props.transitionBack().catch((error) => {
        console.error('Failed to go back from sequence selection: ' + error);
      });
    }
  }

  render() {

    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.locationName.toLocaleUpperCase()}
          subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
          hideOnMobile={true}
        />
        <div className={'SequenceSelection'}>
          <div className={'SequenceSelection-container'}>
            {this.props.sequences.map((sequence, index) => {
              return (
                <div className={'SequenceSelection-container-item'} key={index}>
                  <ClickableBox
                    title={sequence.sequence_name}
                    disabled={false}
                    onClickBox={this.onClickSequence(sequence)}
                    images={sequence.sequence_image_array}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <PriceBar isSubtotal={true} />
        <Footer
          nextName={this.props.languageObj.render.next_name}
          prevName={this.props.languageObj.render.prev_name}
          nextDisabled={true}
          prevDisabled={false}
          handleClickNext={this.onClickNext}
          handleClickPrev={this.onClickPrev}
          nextHidden={true}
        />
        <ToastContainer
          className={'ToastContainer'}
          toastClassName={'Toast'}
          progressClassName={'ToastProgress'}
          position={'top-right'}
          newestOnTop={true}
          rtl={false}
        />
      </div>
    );
  }
}
